import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LoginService } from './../_services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CustomValidator } from './../_services/customValidator';

@Component({
    selector: 'app-resetpassword',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['./resetpassword.component.scss'],
    standalone: false
})
export class ResetpasswordComponent implements OnInit {
  resetpassword: boolean;
  forgetpassword: boolean;
  forgetpassword_form: UntypedFormGroup
  resetpasswordlink: string;
  resetpassword_form: UntypedFormGroup;
  resetpwsuccess: boolean;
  successMessage: any;
  errorMessage: any;


  constructor(private router : Router , private loginservice : LoginService ,public fb:UntypedFormBuilder ,private route :ActivatedRoute) { }

  ngOnInit() {
    if (this.router.url.includes('forgetpassword')) {
      this.forgetpassword = true
    } else if (this.router.url.includes('resetpassword')){
      this.resetpassword = true
      let url = window.location.href;
      this.resetpasswordlink = url;
      this.loginservice.checkpasswordlinkvalidity({ passwordresetlink: url }).subscribe((res: any) => {
        if(res && res.status == 'success'){
          if(!res.isValid){
            this.router.navigate(['expiry']);
          }
        }
      })
    }

    this.forgetpassword_form = this.fb.group({
      emailid: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')])],
    })

    this.resetpassword_form = this.fb.group({
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(48),
        CustomValidator.patternValidator(/\d/, { hasNumber: true }),
        CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
        CustomValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
        CustomValidator.keywordIncludes("password", { hasKeyword: true })
      ])],
      confirmpwd: ['', Validators.required]
    })

  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  reconfirmpwd() {
    if (this.resetpassword_form.value.password == this.resetpassword_form.value.confirmpwd) {
      return this.resetpassword_form['controls'].confirmpwd.setErrors(null)
    } else {
      return this.resetpassword_form['controls'].confirmpwd.setErrors({ 'invalidpwd': true })
    }
  }

  requestlink(){
    let data ={
      "loginemail": this.forgetpassword_form.value.emailid
    }

    this.loginservice.forgetpassword(data).subscribe((res:any)=>{
      this.forgetpassword_form.reset();
        this.toastmessage('If you have an account with us, you will receive an email with instructions to reset your password.', "success");


    })
  }

  resetpwd(){
    if(this.resetpassword_form.valid){
      let data ={
        "password": this.resetpassword_form.value.password,
        "passwordresetlink": this.resetpasswordlink
      }
      this.loginservice.resetpassword(data).subscribe((res:any)=>{
        if(res.status == 'success'){
          this.resetpwsuccess = true;
          this.resetpassword = false;

        }else{
          this.toastmessage("Something Went Wrong","error")
        }
      })
    }else{
      this.validateAllFormFields(this.resetpassword_form)
    }

  }

    validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
